/* @flow */
import * as React from 'react';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import { ElectroButton, BoundTextField } from 'components/ExtendedUiElements/customized.js';
import type { TypeWithEmailModel } from 'models/AccountModels';
import { browserHistory, emailModel } from 'services/ServiceRegistry';

import CentralForm from 'components/CentralForm/CentralForm.js';
import styles from 'common-scss/formstyles.module.scss';
import { PureComponentWithInjectedProps } from '../../utils/injectedProps';

async function go(emailModel: *): Promise<*> {
  const path: string = browserHistory.location.pathname;

  if (path === '/get-magic-link') {
    try {
      await emailModel.requestMagicLink();
      browserHistory.push('magic-link', { success: true });
    } catch (e) {
      browserHistory.push('magic-link', e);
    }
  } else {
    try {
      await emailModel.forgotPassword();
      browserHistory.push('password-reset', { success: true });
      emailModel.resetData();
    } catch (e) {
      emailModel.resetData();
      browserHistory.push('password-reset', e);
    }
  }
}

type InjectedProps = TypeWithEmailModel & TranslatorProps;

@translate()
@inject('emailModel')
@observer
class ForgottenPassword extends PureComponentWithInjectedProps<{}, InjectedProps> {
  render() {
    const { t, emailModel } = this.props;
    const path: string = browserHistory.location.pathname;

    let heading: string = t('general:accounts.reasons.forgotten_password');

    if (path === '/get-magic-link') {
      heading = t('general:accounts.messages.magic_link_sign_in');
    }

    return (
      <CentralForm>
        <form
          onSubmit={(e: *) => {
            e.preventDefault();
            go(emailModel);
          }}
        >
          <h1>{heading}</h1>
          <BoundTextField
            model={emailModel}
            prop="email"
            floatingLabelText={t('general:labels.email_address')}
            hintText={t('general:placeholders.start_typing')}
          />
          <div className={styles['button-group']}>
            <Link to="/login" className={styles['button-anchor']}>
              <ElectroButton label={t('general:actions.cancel')} color="secondary" />
            </Link>

            {path === '/get-magic-link' ? (
              <ElectroButton
                type="submit"
                disabled={!emailModel.valid}
                label={t('general:accounts.get_magic_link')}
                color="primary"
              />
            ) : (
              <ElectroButton
                type="submit"
                disabled={emailModel.loading || !emailModel.valid}
                label={t('general:accounts.reset_password')}
                color="primary"
              />
            )}
          </div>
        </form>
      </CentralForm>
    );
  }
}

export default ForgottenPassword;
